import { Button, Card, CardContent, FormHelperText, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { addEmailTemplate, getEmailTemplates } from "../../Services/API/EmailTemplateService";
import DropdownComponent from "../Dropdown/DropdownComponent";
import LoadingBar from "../LoadingBar/LoadingBar";
import { Functions } from "../TextEditor/Functions";
import { Plugins } from "../TextEditor/Plugins";
import TinyEditor from "../TextEditor/TinyEditor";
import { Toolbar } from "../TextEditor/Toolbar";
import { StyledTextField } from "../TextField/TextField";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  error: {
    color: theme.palette.error.main,
  },
}));

export default function EmailTemplateModal({
  openModal,
  setData,
  setShowSignifier,
  setShowError,
  emailTypes,
  clientId,
}) {
  const classes = useStyles();

  const [showInputError, setShowInputError] = useState(false);
  const [subject, setSubject] = useState("");
  const [htmlBody, setHtmlBody] = useState("");
  const [selectedEmailType, setSelectedEmailType] = useState("");
  const [name, setName] = useState("");
  const [from, setFrom] = useState("");
  const [fromName, setFromName] = useState("");
  const [to, setTo] = useState("");
  const [addProcessing, setAddProcessing] = useState(false);

  const subjectButtons = [
    { title: "User's First Name", val: "[[firstname]]" },
    { title: "User's Last Name", val: "[[lastname]]" },
    { title: "User's Email", val: "[[email]]" },
    { title: "Client Name", val: "[[clientname]]" },
    { title: "Start Day Of Current Week", val: "[[startcurrentweek]]" },
    { title: "End Day Of Current Week", val: "[[endcurrentweek]]" },
    { title: "Event Name", val: "[[eventname]]" },
    { title: "Event Start Date", val: "[[eventstartdate]]" },
    { title: "Event Start Time", val: "[[eventstarttime]]" },
    { title: "Job Title", val: "[[emailapplyjobtitle]]" },
  ];

  const checkAllEntered = () => {
    if (name === "" || from === "" || fromName === "" || subject === "" || htmlBody === "") {
      return false;
    }
    return true;
  };

  const addEmailType = (data) => {
    for (var i in data) {
      data[i].emailTypes = emailTypes;
      var templateType = data[i].emailTemplateType;
      for (var x in emailTypes) {
        if (emailTypes[x].id === templateType) {
          data[i].emailTypeName = emailTypes[x].name;
          break;
        }
      }
    }
    return data;
  };

  const convertDate = (date) => {
    if (!date) return null;
    const parsed = new Date(date);
    return isNaN(parsed.getTime()) ? null : parsed.toLocaleDateString("en-US");
  };

  const submitData = () => {
    if (checkAllEntered()) {
      setAddProcessing(true);
      addEmailTemplate(data).then((response) => {
        getEmailTemplates(clientId).then((res) => {
          setShowSignifier(true);
          if (res) {
            for (var i in res) {
              res[i].dateCreated = convertDate(res[i].dateCreated);
              res[i].dateLastUpdated = convertDate(res[i].dateLastUpdated);
            }
            res = addEmailType(res);
            setData(res);
            openModal(false);
          } else {
            setShowError(true);
          }
          setAddProcessing(false);
        });
      });
    } else {
      setShowInputError(true);
    }
  };

  const createSendToArray = () => {
    var retVal = [];
    if (selectedEmailType === "Talent_Network_Uploaded_Resume" && to !== "") {
      var recipients = to.split(";");
      for (var i in recipients) {
        var newDestination = {
          ClientId: clientId,
          EmailAddress: recipients[i],
        };
        retVal.push(newDestination);
      }
    }

    return retVal;
  };

  const data = {
    ClientId: clientId,
    EmailTemplateType: selectedEmailType.id,
    Name: name,
    Subject: subject,
    Body: htmlBody,
    From: from,
    FromName: fromName,
    EmailResumeDestinations: createSendToArray(),
  };

  return (
    <div className={classes.root}>
      <LoadingBar loading={addProcessing} />
      <Grid>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid xs={12} sm={12} item>
                <p>Add Email Template</p>
              </Grid>
              <Grid xs={12} sm={6} item>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Name"
                  label="Name"
                  variant="standard"
                  fullWidth
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {showInputError && name === "" && (
                  <FormHelperText className={classes.error}>Name Required</FormHelperText>
                )}
              </Grid>
              <Grid xs={12} sm={6} item>
                <DropdownComponent
                  currValue={selectedEmailType}
                  items={emailTypes}
                  property="name"
                  title="Email Type"
                  handleChange={(value) => setSelectedEmailType(value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="From"
                  label="From"
                  variant="standard"
                  fullWidth
                  required
                  value={from}
                  onChange={(e) => setFrom(e.target.value)}
                />
                {showInputError && from === "" && (
                  <FormHelperText className={classes.error}>From Required</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="From Name"
                  label="From Name"
                  variant="standard"
                  fullWidth
                  required
                  value={fromName}
                  onChange={(e) => setFromName(e.target.value)}
                />
                {showInputError && fromName === "" && (
                  <FormHelperText className={classes.error}>From Name Required</FormHelperText>
                )}
              </Grid>
              {selectedEmailType === "Talent_Network_Uploaded_Resume" ? (
                <Grid item xs={12} sm={12}>
                  <StyledTextField
                    InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                    placeholder="To"
                    label="To ( ; delimited, if multiple)"
                    variant="standard"
                    fullWidth
                    value={to}
                    onChange={(e) => setTo(e.target.value)}
                  />
                </Grid>
              ) : null}
              {subjectButtons.map((button, index) => (
                <Grid item xs={3} sm={1}>
                  <Button
                    size="small"
                    style={{
                      width: "100%",
                      height: "70px",
                      marginTop: "20px",
                      fontSize: "11px",
                      lineHeight: "14px",
                    }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => setSubject(subject + button.val)}
                  >
                    {button.title}
                  </Button>
                </Grid>
              ))}
              <Grid item xs={12} sm={12}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Subject"
                  label="Subject"
                  variant="standard"
                  fullWidth
                  required
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
                {showInputError && subject === "" && (
                  <FormHelperText className={classes.error}>Subject Required</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={12}>
                <TinyEditor
                  value={htmlBody}
                  setValue={setHtmlBody}
                  plugins={Plugins}
                  toolbar={Toolbar}
                  functions={Functions}
                />
                {showInputError && htmlBody === "" && (
                  <FormHelperText className={classes.error}>Body Required</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={12} container justifyContent="flex-end">
                <Button
                  style={{ marginTop: "20px" }}
                  type="submit"
                  variant="outlined"
                  color="primary"
                  disabled={addProcessing}
                  onClick={() => openModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  style={{ marginTop: "20px", marginLeft: "20px" }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={addProcessing}
                  onClick={() => submitData()}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
